import { useLanguage } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/Reveal";

export const Privacy = () => {
  const { t } = useLanguage();
  const p = t.privacy;
  return (
    <section id="privacy" className="relative py-24 md:py-32">
      <div className="container-page max-w-4xl">
        <Reveal>
          <span className="overline text-[#CEA26B]">{p.overline}</span>
          <h1 className="mt-4 font-display font-bold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl leading-tight" data-testid="privacy-title">
            {p.title}
          </h1>
          <p className="mt-3 text-sm text-slate-500">{p.updated}</p>
          <p className="mt-6 text-base md:text-lg text-slate-300 leading-relaxed">{p.intro}</p>
        </Reveal>
        <div className="mt-12 space-y-10">
          {p.sections.map((sec, i) => (
            <Reveal key={i} delay={0.03 * i}>
              <div data-testid={`privacy-section-${i}`}>
                <h2 className="font-display font-bold text-white text-xl md:text-2xl border-l-2 border-[#CEA26B] pl-4">
                  {sec.h}
                </h2>
                {(sec.ps || []).map((par, j) => (
                  <p key={j} className="mt-4 text-base text-slate-300 leading-relaxed">{par}</p>
                ))}
                {sec.list && (
                  <ul className="mt-4 space-y-2">
                    {sec.list.map((li, j) => (
                      <li key={j} className="flex gap-3 text-base text-slate-300 leading-relaxed">
                        <span className="mt-2.5 h-1.5 w-1.5 shrink-0 rotate-45 bg-[#CEA26B]" />
                        {li}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
